// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import Playlist from "./Playlist";
import SocialTheme, { processSocialTheme } from "./SocialTheme";

export default interface SocialTemplate {
    socialTemplateId?: string;
    templateName?: string;
    description?: string;
    theme?: SocialTheme;
    playlist?: Playlist;
}

export function processSocialTemplate(value?: SocialTemplate): void {
  if (value) {
    processSocialTheme(value.theme);
  }
}

export function processSocialTemplateArray(array?: SocialTemplate[]): void {
  if (array) {
    for (const v of array) {
      processSocialTemplate(v);
    }
  }
}
